import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { useProfile } from '../contexts/ProfileContext';

interface ProtectedRouteProps {
  children: React.ReactNode;
  requireSupervisor?: boolean;
  requireEmployee?: boolean;
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ 
  children, 
  requireSupervisor = false,
  requireEmployee = false 
}) => {
  const { user, loading } = useAuth();
  const { profile } = useProfile();
  const location = useLocation();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-indigo-500"></div>
      </div>
    );
  }

  if (!user) {
    // Guardar la ubicación actual para redirigir después del login
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  // Verificar roles específicos
  if (requireSupervisor && profile?.role !== 'supervisor') {
    return <Navigate to="/dashboard" replace />;
  }

  if (requireEmployee && profile?.role !== 'employee') {
    return <Navigate to="/dashboard" replace />;
  }

  // Redirigir a dashboard para todos los usuarios
  if (location.pathname === '/') {
    return <Navigate to="/dashboard" replace />;
  }

  return <>{children}</>;
};

export default ProtectedRoute;
